export const LISTING_ADD_PARTY_ROLES = [
  { value: 'seller', label: 'Seller' },
  { value: 'sellers_agent', label: "Seller's Agent" },
  { value: 'sellers_managing_broker', label: "Seller's Managing Broker" },
  { value: 'sellers_referring_agent', label: "Seller's Referring Agent" },
  { value: 'title_officer', label: 'Title Officer' },
  { value: 'escrow_officer', label: 'Escrow Officer' },
  { value: 'real_estate_attorney', label: 'Real Estate Attorney' },
  { value: 'sellers_transaction_coordinator', label: "Seller's Transaction Coordinator" },
  { value: 'participant', label: 'Participant' },
];

const LEGACY_LISTING_ROLE_VALUES = {
  co_seller: 'seller',
  'co-seller': 'seller',
  coseller: 'seller',
  listing_agent: 'sellers_agent',
  'listing agent': 'sellers_agent',
  co_listing_agent: 'sellers_agent',
  'co listing agent': 'sellers_agent',
  'co-listing agent': 'sellers_agent',
  managing_broker: 'sellers_managing_broker',
  'managing broker': 'sellers_managing_broker',
  transaction_coordinator: 'sellers_transaction_coordinator',
  'transaction coordinator': 'sellers_transaction_coordinator',
  tc: 'sellers_transaction_coordinator',
};

export const LISTING_TEAM_ROLE_ORDER = [
  'sellers_agent',
  "seller's agent",
  'listing_agent',
  'sellers_managing_broker',
  'sellers_referring_agent',
  'escrow_officer',
  'title_officer',
  'real_estate_attorney',
  'sellers_transaction_coordinator',
  'transaction coordinator',
  'tc',
  'participant',
];

export function canonicalListingRoleValue(roleVal) {
  const raw = String(roleVal || '').trim();
  if (!raw) return 'seller';
  const lower = raw.toLowerCase();
  if (LEGACY_LISTING_ROLE_VALUES[lower]) return LEGACY_LISTING_ROLE_VALUES[lower];
  const match = LISTING_ADD_PARTY_ROLES.find(
    (role) => role.value === raw || role.value === lower || role.label.toLowerCase() === lower,
  );
  return match ? match.value : raw;
}

export function listingRoleLabel(roleVal) {
  if (!roleVal) return '';
  const canonical = canonicalListingRoleValue(roleVal);
  const match = LISTING_ADD_PARTY_ROLES.find((role) => role.value === canonical);
  if (match) return match.label;
  return String(roleVal).replace(/_/g, ' ');
}

export function listingTeamSortIndex(role) {
  const normalized = (role || '').toLowerCase();
  const idx = LISTING_TEAM_ROLE_ORDER.findIndex(
    (value) => normalized.includes(value) || value.includes(normalized),
  );
  return idx === -1 ? LISTING_TEAM_ROLE_ORDER.length : idx;
}

export function isListingSellerPrincipal(role) {
  if (!role) return false;
  const normalized = role.toLowerCase();
  return (
    (normalized.includes('seller') || normalized.includes('co_seller') || normalized === 'co-seller')
    && !normalized.includes('agent')
    && !normalized.includes('broker')
    && !normalized.includes('coordinator')
    && !normalized.includes('tc')
  );
}
